





















export default
    methods:
        select: (key) ->
            @$store.commit('sort/SET_CHOICE', key)
